import Payment from '../../components/WebsiteComponents/Payment';
import Companies from '../../components/WebsiteComponents/Companies';
import InitialAppointment from '../../components/WebsiteComponents/InitialAppointment';
export const Insurance = () => {
    return (
        <> 
<Companies/>
<Payment/>
<InitialAppointment/>
    </>
       
    );
}